//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from 'vuelidate/lib/validators';

import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';
import PredictionMixin from '@/components/mixins/prediction.mixin.js';

export default {
  name: 'BackgroundRemover',
  mixins: [AiToolsMixin, PredictionMixin],
  components: {
    ToolImageLayout: () => import('@/components/core/ToolImageLayout.vue'),
    SourceImage: () => import('@/components/tools/SourceImage.vue'),
    DemoSourceImages: () => import('@/components/tools/DemoSourceImages.vue'),
  },
  data() {
    return {
      form: {
        model: 'image_remove_background',
        image: null,
      },
      demoImage: null,
      prediction: {
        model: 'image_remove_background',
        image: null,
      },
      demoImages: [
        {
          labelImage: 'https://static.moele.me/img/studio-ai/background_remover/asian-men.png?auto=format&w=88',
          value: 'asian-men',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/background_remover/men.png?auto=format&w=88',
          value: 'men',
        },
        {
          labelImage: 'https://static.moele.me/img/studio-ai/background_remover/women.png?auto=format&w=88',
          value: 'women',
        },
      ],
    };
  },
  validations: {
    form: {
      image: {
        required: required,
      },
    },
  },
  computed: {
    tool() {
      return this.aiTools.find(({ id }) => id === this.aiToolsIds.BACKGROUND_REMOVER);
    },
    demoOutput() {
      if (this.demoImage) {
        return [{ preview: { url: `https://static.moele.me/img/studio-ai/${this.aiToolsIds.BACKGROUND_REMOVER}/output/${this.demoImage}.png?auto=format&w=524` } }];
      }
      return null;
    },
  },
  methods: {
    clearForm() {
      if (document.querySelector('input[type=file]')) {
        document.querySelector('input[type=file]').value = null;
      }
      this.form.image = null;
      this.demoImage = null;
      this.form.pastUploadedImage = null;
    },
    setFormFromResponse(response) {
      this.form.image = _.get(response, 'input.image');
      this.prediction.image = _.get(response, 'input.image');
    },
  },
};
